import React, { ReactNode } from "react";
import {
  AccountSettingsStore,
  PurchaseStore,
  RolesAndPermissionStore,
} from "../../shared/store";
import {
  RelatedItemsPriceCategoriesModel,
  PurchasePaymentIntentModel,
  PriceTermSettings,
  StandardPricingModel,
  DonationPricingPageInputsModel,
  CustomerFacingCheckOutItemModel,
  PurchaseCheckOutDetails,
  PurchaseCheckOutAddOnDetails,
  CustomerFacingCheckOutModel,
  PurchasePaymentModel,
} from "../../shared/models";
import { observer } from "mobx-react";
import {
  Routes,
  Route,
  Navigate,
  NavigateFunction,
  Params,
} from "react-router-dom";
import { Subject, takeUntil } from "rxjs";
import PurchaseProtectedRoute from "./PurchaseProtectedRoute";
import PurchaseAddOn from "./PurchaseAddOn";
import PurchaseOptions from "./PurchaseOptions";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  IAPIResponse,
  Input,
  Loader,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { CheckOutService, PurchaseLinkService } from "../../shared/services";
import { IAPIPurchaseCheckOutItemsModel } from "../../shared/interfaces";
import {
  ImagePlacementTypes,
  PricingModel,
  RecurringBillingInterval,
  UpsertPurchaseActiveStep,
} from "../../shared/enums";
import {
  DonationItem,
  MultipleItems,
  PurchasePayment,
  PurchaseSection,
  PurchaseSuccess,
  PurchaseTopBar,
  SingleItemMultiplePrices,
} from "../../shared/components";
import {
  PurchaseColoredBackground,
  PurchaseWrapper,
} from "../../shared/styles";

interface IProps {
  location: Location;
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
  purchaseStore: PurchaseStore;
  isPurchaseLink: boolean;
  rolesAndPermissionStore: RolesAndPermissionStore;
}

type IState = {
  isPaymentInProgress: boolean;
};

class PurchaseRoutes extends React.Component<IProps, IState> {
  private loader: Loader = new Loader(true);
  private paymentLoader: Loader = new Loader(false);
  private $destroy: Subject<boolean> = new Subject<boolean>();
  private isPaymentInProgress: boolean = false;

  constructor(props: IProps) {
    super(props);
    this.state = {
      isPaymentInProgress: false,
    };
  }

  componentDidMount(): void {
    this.purchaseStore.reset();
    const id = this.checkOutId;

    if (this.props.isPurchaseLink) {
      PurchaseLinkService.getPurchaseLink("", id)
        .pipe(takeUntil(this.$destroy))
        .subscribe({
          next: (response) => {
            if (response.result) {
              this.purchaseStore.deserializePurchaseLinkToCustomerFacing(
                response.result
              );
            }
            this.loader.hide();
          },
          error: () => {
            ToastService.showError("Error in loading purchase link details");
            this.loader.hide();
          },
        });
    } else {
      CheckOutService.getCustomerFacingCheckOutDetails(id)
        .pipe(takeUntil(this.$destroy))
        .subscribe({
          next: (result) => {
            if (!result.result) {
              ToastService.showError("Error in loading checkout details");
              this.loader.hide();
            } else {
              this.purchaseStore.deserializeCustomerFacingCheckOutModel(
                result.result
              );
            }
            this.loader.hide();
          },
          error: () => {
            ToastService.showError("Error in loading checkout details");
            this.loader.hide();
          },
        });
    }
  }

  get checkOutId() {
    const split = ((this.props.params && this.props.params["*"]) || "").split(
      "/"
    );
    const id =
      split[split.length - 1] === "success"
        ? split[split.length - 2]
        : split[split.length - 1];

    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return "";
  }

  get purchaseStore(): PurchaseStore {
    return this.props.purchaseStore || new PurchaseStore();
  }

  onPurchaseClick = (
    item: CustomerFacingCheckOutItemModel,
    quantity?: number
  ) => {
    const clonedPurchaseDetails = new PurchaseCheckOutDetails(
      this.purchaseStore.checkOutPurchaseDetails || undefined
    );
    if (item.isTrackInventory) {
      //only select active variant index.
      // if (item.hasVariants) {
      //     const variantIndex = item.variants?.options?.findIndex(
      //         (x) => x.isRemoved != true && x.onHand && parseFloat(x.onHand) > 0,
      //     );
      //     if (variantIndex !== -1) {
      //         item.selectedVariantIndex = variantIndex;
      //     }
      // }
    }
    if (
      item.includedItemsByCondition &&
      item.includedItemsByCondition.length === 0
    ) {
      item.includedItemsByCondition = item.getAllowedIncludedItems();
    }

    clonedPurchaseDetails.item = item;
    clonedPurchaseDetails.addOns = [];
    clonedPurchaseDetails.activeItemIndex = -1;
    if (quantity) {
      clonedPurchaseDetails.item.quantity = quantity;
    }

    // const clonedRequiredItems = item.requiredItems?.map((r) => new RelatedItemsCategoriesModel(r)) || [];
    // const addOns: PurchaseCheckOutAddOnDetails[] = clonedPurchaseDetails.addOns || [];

    // if (clonedRequiredItems.length > 0 && addOns.length === 0) {
    //     clonedRequiredItems.map((r) => {
    //         if (r.requiredVariantIds?.length > 0) {
    //             const requiredOptions = r.variants?.options?.filter(
    //                 (o) => indexOf(r.requiredVariantIds, o.id) !== -1,
    //             );

    //             const clonedVariant = new ProductAttributeInputModel({ ...r, options: requiredOptions });
    //             const price = r.prices?.find((p) => p.isDefaultPrice) || r.prices?.[0];
    //             const newAddOn = new PurchaseCheckOutAddOnDetails({
    //                 ...price,
    //                 id: r.id,
    //                 name: r.name,
    //                 itemId: r.id,
    //                 itemType: r.type,
    //                 variantId: r.requiredVariantIds[0],
    //                 quantity: 1,
    //                 selectedVariant: clonedVariant,
    //                 hasVariants: r.hasVariants,
    //                 onlyAllowedVariantIds: r.requiredVariantIds,
    //             });
    //             addOns.push(newAddOn);
    //             // return r.requiredVariantIds?.map((v) => {
    //             //     //id here is the id of product/membership or service
    //             //     const matchedAddOn = addOns.find((x) => x.variantId === v);
    //             //     if (!matchedAddOn) {
    //             //         const newAddOn = new PurchaseCheckOutAddOnDetails({
    //             //             id: r.id,
    //             //             name: r.name,
    //             //             itemId: r.id,
    //             //             itemType: r.type,
    //             //             variantId: v,
    //             //             quantity: 1,
    //             //             selectedVariant: r.variants,
    //             //             hasVariants: r.hasVariants,
    //             //         });
    //             //         addOns.push(newAddOn);
    //             //     }
    //             // });
    //         } else {
    //             const price = r.prices?.find((p) => p.isDefaultPrice) || r.prices?.[0];
    //             const newAddOn = new PurchaseCheckOutAddOnDetails({
    //                 ...price,
    //                 name: r.name,
    //                 quantity: 1,
    //                 itemId: r.id,
    //                 itemType: r.type,
    //                 hasVariants: r.hasVariants,
    //                 selectedVariant: r.variants,
    //                 variantId: r.variants?.options?.[0]?.id || '',
    //             });
    //             addOns.push(newAddOn);
    //         }
    //     });
    // }
    // clonedPurchaseDetails.addOns = addOns;
    this.purchaseStore.updateCheckOutPurchaseDetails(clonedPurchaseDetails);

    const hasError = this.purchaseStore.checkOutPurchaseDetails?.item.hasError(
      "customPricingInputValue"
    );
    if (hasError) return;
    this.handleBackOrNextStep(true);
  };

  updateAddOns(addOns: PurchaseCheckOutAddOnDetails[]) {
    const clonedPurchaseDetails = new PurchaseCheckOutDetails(
      this.purchaseStore.checkOutPurchaseDetails || undefined
    );

    clonedPurchaseDetails.addOns = addOns;
    this.purchaseStore.updateCheckOutPurchaseDetails(clonedPurchaseDetails);
  }

  // updateOptionsPageData = (data: OptionSectionModel) => {
  //     this.purchaseStore.updateOptionsPageData(new OptionSectionModel(data));
  // };

  onPayClick() {
    if (this.state.isPaymentInProgress) return;

    this.setState({ isPaymentInProgress: true });
    const request = this.purchaseStore.createCheckOutAPIPurchaseModel(
      this.checkOutId,
      this.includeSurcharge()
        ? parseFloat(
            this.purchaseStore.customerFacingCheckOutDetails.merchantAccount
              .paymentSettings.cards.surchargePercentage
          )
        : 0
    );

    const handleSuccess = async (
      result: IAPIResponse<IAPIPurchaseCheckOutItemsModel>
    ) => {
      if (result.result?.success) {
        try {
          await this.purchaseStore.updateActiveStep(
            UpsertPurchaseActiveStep.Success
          );

          const isDonation =
            this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly;
          const donationFrequency = this.purchaseStore
            .customerFacingCheckOutDetails.donationPricingPageData?.oneTime
            ? "One Time"
            : "Monthly";
          await this.purchaseStore.setPurchaseDoneResponse(
            result.result,
            isDonation,
            donationFrequency
          );
          await this.purchaseStore.togglePurchaseDone();
          this.props.navigate(
            `/app/purchase/${this.props.isPurchaseLink ? "purchase-link" : "checkout"}/success/${this.checkOutId}`
          );
        } catch (error) {
          this.setState({ isPaymentInProgress: false });
          ToastService.showError("Error in processing the purchase");
        }
      } else {
        this.setState({ isPaymentInProgress: false });
        ToastService.showError("Error in purchasing items");
      }
    };

    const handleError = () => {
      this.setState({ isPaymentInProgress: false });
      ToastService.showError("Error in purchasing items");
    };

    if (this.props.isPurchaseLink) {
      PurchaseLinkService.purchaseLinkCheckoutItems(request).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    } else {
      CheckOutService.purchaseCheckOutItems(request).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    }
  }

  updateDonationPricingPageData(
    donationPricingPageData: DonationPricingPageInputsModel
  ) {
    this.purchaseStore.updateCustomerFacingCheckOutModel(
      new CustomerFacingCheckOutModel({
        ...this.purchaseStore.customerFacingCheckOutDetails,
        donationPricingPageData: donationPricingPageData,
      })
    );
  }

  onDonationClick = () => {
    const {
      oneTime,
      donationAmout,
      customAmount,
      allowAnonymousDonation,
      annualIncrease,
      annualIncreasePercentage,
      coverProcessingCost,
      offerInMemoryOf,
      inMemoryOfComment,
      inMemoryOfName,
      selectedBeneficiaries,
      coverProcessingCostDescription,
    } =
      this.purchaseStore.customerFacingCheckOutDetails.donationPricingPageData;
    const item =
      this.purchaseStore.customerFacingCheckOutDetails.items?.length > 0
        ? this.purchaseStore.customerFacingCheckOutDetails.items[0]
        : null;
    const isValid =
      this.purchaseStore.customerFacingCheckOutDetails.donationPricingPageData.validateForCustomerFacing();
    if (!isValid) return;
    const donationAmount =
      donationAmout > 0 ? donationAmout : parseFloat(customAmount);
    const priceModel = new RelatedItemsPriceCategoriesModel({
      terms: new PriceTermSettings({
        initialPayment: donationAmount,
        totalPayments: donationAmount,
        billingInterval: oneTime
          ? RecurringBillingInterval.Day
          : RecurringBillingInterval.Month,
        billingIntervalCount: 1,
        pricingModel: PricingModel.Standard,
        standardPricing: new StandardPricingModel({
          originalPrice: donationAmount,
          price: donationAmount,
          cost: donationAmount,
        }),
      }),
    });

    const hasAmountChange =
      donationAmount !==
      this.purchaseStore.checkOutPurchaseDetails?.item?.donationAmount;
    const donationItems = new CustomerFacingCheckOutItemModel({
      ...item,
      id:
        item?.itemId ||
        this.purchaseStore.customerFacingCheckOutDetails.donationDetailPage
          .category?.id ||
        "",
      name:
        item?.name ||
        this.purchaseStore.customerFacingCheckOutDetails.donationDetailPage
          .name,
      quantity: 1,
      priceInNumber: 1,
      price: priceModel,
      donationAmount: donationAmount,
      payMonthly: !oneTime,
      inMemoryOf: offerInMemoryOf ?? false,
      tributeMessage: inMemoryOfComment,
      dedicatedTo: inMemoryOfName,
      beneficiaries: selectedBeneficiaries,
      allowAnnualIncrease: annualIncrease ?? false,
      annualIncreasePercentage: annualIncreasePercentage,
      anonymousDonation: allowAnonymousDonation ?? false,
      coverFee: coverProcessingCost ?? false,
      coverFeeMessage: coverProcessingCostDescription,
      requiredItems: item?.requiredItems || [],
      recommendedItems: item?.recommendedItems || [],
      includedItems: item?.includedItems || [],
      //   recommendedItems: [
      //     new RelatedItemsCategoriesModel({
      //       prices: [priceModel],
      //     }),
      //   ],
    });

    if (hasAmountChange) {
      donationItems.includedItemsByCondition =
        donationItems.getAllowedIncludedItems();
    } else {
      donationItems.includedItemsByCondition =
        this.purchaseStore.checkOutPurchaseDetails?.item?.includedItemsByCondition;
    }

    this.purchaseStore.updateCheckOutPurchaseDetails(
      new PurchaseCheckOutDetails({
        ...this.purchaseStore.checkOutPurchaseDetails,
        addOns: hasAmountChange
          ? []
          : this.purchaseStore.checkOutPurchaseDetails?.addOns,
        activeItemIndex: 0,
        item: donationItems,
      })
    );
    this.handleBackOrNextStep(true);
  };

  // updateItem(item: CustomerFacingCheckOutItemModel) {
  //     const clonedPurchaseDetails = new PurchaseCheckOutDetails(
  //         this.purchaseStore.checkOutPurchaseDetails || undefined,
  //     );
  //     clonedPurchaseDetails.item = new CustomerFacingCheckOutItemModel(item);
  //     this.purchaseStore.updateCheckOutPurchaseDetails(clonedPurchaseDetails);
  // }

  updateItems(items: CustomerFacingCheckOutItemModel[]) {
    const clonedPurchaseDetails = new CustomerFacingCheckOutModel({
      ...this.purchaseStore.customerFacingCheckOutDetails,
      items: items,
    });
    this.purchaseStore.updateCustomerFacingCheckOutModel(clonedPurchaseDetails);
  }

  get classBasedOnActiveStep() {
    switch (this.purchaseStore.activeStep) {
      case UpsertPurchaseActiveStep.Purchase:
        return "";
      case UpsertPurchaseActiveStep.AddOn:
        return "purchase-addon-screen";
      case UpsertPurchaseActiveStep.Options:
        return "purchase-options-screen";
      case UpsertPurchaseActiveStep.Payment:
        return "purchase-payment-section";
      default:
        return "";
    }
  }

  get purchaseSectionComponent() {
    const isDonationOnly =
      this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly;
    switch (this.purchaseStore.customerFacingCheckOutDetails.displayType) {
      case "SingleItemWithMultiplePrices":
        return (
          <SingleItemMultiplePrices
            purchaseStore={this.purchaseStore}
            onPurchaseClick={(item: CustomerFacingCheckOutItemModel) =>
              this.onPurchaseClick(item)
            }
            items={this.purchaseStore.customerFacingCheckOutDetails.getSortedItems()}
            recommendedItem={
              this.purchaseStore.customerFacingCheckOutDetails.recommendedItem
            }
            color={this.purchaseStore.getColors()}
            buttonCaption={this.purchaseStore.getButtonCaption()}
            buttonStyle={this.purchaseStore.getButtonStyle()}
            updateItems={(items: CustomerFacingCheckOutItemModel[]) =>
              this.updateItems(items)
            }
            customOption={
              this.purchaseStore.customerFacingCheckOutDetails.customOption
            }
            allowIncludedItems={
              this.purchaseStore.customerFacingCheckOutDetails
                .allowIncludedItems
            }
          />
        );
      case "MultipleItems":
        return (
          <MultipleItems
            recommendedItem={
              this.purchaseStore.customerFacingCheckOutDetails.recommendedItem
            }
            purchaseStore={this.purchaseStore}
            items={this.purchaseStore.customerFacingCheckOutDetails.getSortedItems()}
            onPurchaseClick={(item: CustomerFacingCheckOutItemModel) =>
              this.onPurchaseClick(item)
            }
            groupByBillingFrequency={
              this.purchaseStore.customerFacingCheckOutDetails
                .groupByBillingFrequency
            }
            colors={this.purchaseStore.getColors()}
            buttonCaption={this.purchaseStore.getButtonCaption()}
            buttonStyle={this.purchaseStore.getButtonStyle()}
            updateItems={(items: CustomerFacingCheckOutItemModel[]) =>
              this.updateItems(items)
            }
            customOption={
              this.purchaseStore.customerFacingCheckOutDetails.customOption
            }
            allowIncludedItems={
              this.purchaseStore.customerFacingCheckOutDetails
                .allowIncludedItems
            }
          />
        );
      case "MultipleItemsInbundle":
      case "SingleItem":
        if (isDonationOnly)
          return (
            <DonationItem
              customerFacingCheckOutDetails={
                this.purchaseStore.customerFacingCheckOutDetails
              }
              updateDonationPricingPageData={(
                data: DonationPricingPageInputsModel
              ) => this.updateDonationPricingPageData(data)}
              onDonationClick={() => this.onDonationClick()}
              isPreview={false}
            />
          );
        return (
          <PurchaseSection
            item={this.purchaseStore.customerFacingCheckOutDetails.items[0]}
            purchaseStore={this.purchaseStore}
            onPurchaseClick={(
              item: CustomerFacingCheckOutItemModel,
              quantity: number
            ) => this.onPurchaseClick(item, quantity)}
            colors={this.purchaseStore.getColors()}
            buttonCaption={this.purchaseStore.getButtonCaption()}
            buttonStyle={this.purchaseStore.getButtonStyle()}
            updateItem={(item: CustomerFacingCheckOutItemModel) => {
              const clonedItems =
                this.purchaseStore.customerFacingCheckOutDetails.items.map(
                  (item) => {
                    return new CustomerFacingCheckOutItemModel(item);
                  }
                );

              clonedItems[0] = item;
              this.updateItems(clonedItems);
            }}
            allowIncludedItems={
              this.purchaseStore.customerFacingCheckOutDetails
                .allowIncludedItems
            }
          />
        );
      default:
        break;
    }
  }

  hasSurchargeInItemsAndPaySettings = (): boolean => {
    const { checkOutPurchaseDetails, customerFacingCheckOutDetails } =
      this.purchaseStore;
    if (!checkOutPurchaseDetails) return false;

    const itemHasSurcharge =
      checkOutPurchaseDetails.item.hasSurcharge ||
      checkOutPurchaseDetails.addOns.some((addon) => addon.hasSurcharge);

    const paymentMethodHasSurcharge =
      customerFacingCheckOutDetails.merchantAccount.paymentSettings.cards
        .isEnabled &&
      customerFacingCheckOutDetails.merchantAccount.surchargePercentage() > 0;
    return itemHasSurcharge && paymentMethodHasSurcharge;
  };

  showSurchargeCheckbox = (): boolean => {
    const { customerFacingCheckOutDetails } = this.purchaseStore;
    return (
      this.hasSurchargeInItemsAndPaySettings() &&
      customerFacingCheckOutDetails.paymentDetails.surchargeType ===
        "AskPermission"
    );
  };

  includeSurcharge = (): boolean => {
    const {
      customerFacingCheckOutDetails,
      paymentSectionData,
      checkOutPurchaseDetails,
    } = this.purchaseStore;
    if (this.props.isPurchaseLink) {
      return (
        this.hasSurchargeInItemsAndPaySettings() &&
        (checkOutPurchaseDetails?.item.purchaseLinkSurcharge || false)
      );
    } else {
      return (
        (this.showSurchargeCheckbox() && paymentSectionData.surchargeChecked) ||
        (customerFacingCheckOutDetails.paymentDetails.surchargeType ===
          "IncludeSurcharge" &&
          this.hasSurchargeInItemsAndPaySettings())
      );
    }
  };

  get routes() {
    const isPaymentPage =
      this.purchaseStore.activeStep === UpsertPurchaseActiveStep.Payment;
    const showBackButton =
      !this.purchaseStore.purchaseDone &&
      this.purchaseStore.activeStep !== UpsertPurchaseActiveStep.Purchase;
    const showNextButton =
      !this.purchaseStore.purchaseDone &&
      this.purchaseStore.activeStep !== UpsertPurchaseActiveStep.Payment &&
      this.purchaseStore.activeStep !== UpsertPurchaseActiveStep.Purchase;
    const colors = this.purchaseStore.getColors();

    return (
      <PurchaseColoredBackground
        outerBorder={colors?.outerBorder?.rgba}
        outerColor={colors?.outerBackground?.rgba}
        innerBorder={colors?.innerBorder?.rgba}
        innerColor={isPaymentPage ? undefined : colors?.innerBackground?.rgba}
        className={`${
          this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly &&
          this.purchaseStore.customerFacingCheckOutDetails.donationCheckout
            .imagePlacement === ImagePlacementTypes.Background
            ? "colored-bg-with-image"
            : this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly
              ? "purchase-colored-donation-only"
              : ""
        } ${this.classBasedOnActiveStep} `}
        padding={
          this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly &&
          this.purchaseStore.activeStep === UpsertPurchaseActiveStep.Purchase
            ? "0px"
            : "40px 30px"
        }
      >
        <div
          className={`purchase-section ${
            this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly &&
            this.purchaseStore.activeStep !== UpsertPurchaseActiveStep.Payment
              ? "donation-routes-purchase-section"
              : ""
          }`}
        >
          {this.paymentLoader.showLoader ? (
            this.paymentLoader.loaderComponent
          ) : (
            <>
              <Routes>
                <Route
                  path={`/:id`}
                  element={
                    <PurchaseProtectedRoute
                      checkOutId={this.checkOutId}
                      currentRoute={UpsertPurchaseActiveStep.Purchase}
                      purchaseStore={this.purchaseStore}
                      isPurchaseLink={this.props.isPurchaseLink}
                    >
                      <div className="flex-auto-grow">
                        {this.purchaseSectionComponent}
                      </div>
                    </PurchaseProtectedRoute>
                  }
                />
                <Route
                  path={`/addons/:id?`}
                  element={
                    <PurchaseProtectedRoute
                      checkOutId={this.checkOutId}
                      currentRoute={UpsertPurchaseActiveStep.AddOn}
                      purchaseStore={this.purchaseStore}
                      isPurchaseLink={this.props.isPurchaseLink}
                    >
                      <div className="flex-auto-grow">
                        <PurchaseAddOn
                          colors={colors}
                          purchaseStore={this.purchaseStore}
                          itemName={
                            this.purchaseStore.checkOutPurchaseDetails?.item
                              ?.name || ""
                          }
                          addOns={
                            this.purchaseStore.checkOutPurchaseDetails
                              ?.addOns || []
                          }
                          requiredItems={
                            this.purchaseStore.checkOutPurchaseDetails?.item?.getAllowedRequiredItems() ||
                            []
                          }
                          recommendedItems={
                            this.purchaseStore.checkOutPurchaseDetails?.item?.getAllowedRecommendedItems() ||
                            []
                          }
                          relatedItems={
                            this.purchaseStore.checkOutPurchaseDetails?.item
                              .relatedItems
                          }
                          updateAddOns={(
                            addOns: PurchaseCheckOutAddOnDetails[]
                          ) => this.updateAddOns(addOns)}
                        />
                      </div>
                    </PurchaseProtectedRoute>
                  }
                />
                <Route
                  path={`/options/:id?`}
                  element={
                    <PurchaseProtectedRoute
                      checkOutId={this.checkOutId}
                      currentRoute={UpsertPurchaseActiveStep.Options}
                      purchaseStore={this.purchaseStore}
                      isPurchaseLink={this.props.isPurchaseLink}
                    >
                      <div className="flex-auto-grow">
                        <PurchaseOptions
                          onUpdatePurchaseDetails={(data) =>
                            this.purchaseStore.updateCheckOutPurchaseDetails(
                              data
                            )
                          }
                          purchaseOutDetails={
                            this.purchaseStore.checkOutPurchaseDetails ||
                            new PurchaseCheckOutDetails()
                          }
                          // handleNextOrBack={(isNext: boolean) => this.handleBackOrNextStep(isNext)}
                          // updateOptionsPageData={(data: OptionSectionModel) =>
                          //     this.updateOptionsPageData(data)
                          // }
                          //optionsPageData={this.purchaseStore.optionSectiondata}
                        />
                      </div>
                    </PurchaseProtectedRoute>
                  }
                />
                <Route
                  path={`/payment/:id?`}
                  element={
                    <PurchaseProtectedRoute
                      checkOutId={this.checkOutId}
                      currentRoute={UpsertPurchaseActiveStep.Payment}
                      purchaseStore={this.purchaseStore}
                      isPurchaseLink={this.props.isPurchaseLink}
                    >
                      <div className="flex-auto-grow">
                        {this.purchaseStore.paymentIntent && (
                          <PurchasePayment
                            allowedPaymentMethods={
                              this.props.purchaseStore
                                .customerFacingCheckOutDetails.options
                                ?.selectedPaymentMethods || []
                            }
                            merchantAccount={
                              this.props.purchaseStore
                                .customerFacingCheckOutDetails.merchantAccount
                            }
                            includeSurcharge={this.includeSurcharge()}
                            showSurchargeCheckbox={this.showSurchargeCheckbox()}
                            seller={
                              this.props.purchaseStore
                                .customerFacingCheckOutDetails.seller
                            }
                            color={colors}
                            isPaymentInProgress={this.state.isPaymentInProgress}
                            onPaymentMethodIdUpdate={(
                              paymentMethodId: string
                            ) => {
                              this.purchaseStore.updatePaymentSectionData(
                                new PurchasePaymentModel({
                                  ...this.props.purchaseStore
                                    .paymentSectionData,
                                  paymentMethodId: paymentMethodId,
                                })
                              );
                            }}
                            paymentIntent={this.purchaseStore.paymentIntent}
                            items={[
                              this.purchaseStore.checkOutPurchaseDetails
                                ?.item || new CustomerFacingCheckOutItemModel(),
                            ]}
                            addOns={
                              this.purchaseStore.checkOutPurchaseDetails
                                ?.addOns || []
                            }
                            handleNextOrBack={(isNext: boolean) =>
                              this.handleBackOrNextStep(isNext)
                            }
                            selectedVariantIndex={
                              this.purchaseStore.optionSectiondata
                                .selectedVariantIndex
                            }
                            updateItems={(
                              items: CustomerFacingCheckOutItemModel[]
                            ) =>
                              this.purchaseStore.updateCheckOutPurchaseDetails(
                                new PurchaseCheckOutDetails({
                                  ...this.purchaseStore.checkOutPurchaseDetails,
                                  item: items[0],
                                })
                              )
                            }
                            updateAddOns={(
                              addOns: PurchaseCheckOutAddOnDetails[]
                            ) => this.updateAddOns(addOns)}
                            payDetails={
                              this.purchaseStore.customerFacingCheckOutDetails
                                .paymentDetails
                            }
                            paymentSectionData={
                              new PurchasePaymentModel({
                                ...this.purchaseStore.paymentSectionData,
                                paymentDetails:
                                  this.purchaseStore
                                    .customerFacingCheckOutDetails
                                    .paymentDetails,
                              })
                            }
                            updatePaymentSectionData={(
                              data: PurchasePaymentModel
                            ) =>
                              this.purchaseStore.updatePaymentSectionData(data)
                            }
                            countriesWithState={
                              this.purchaseStore.countryStore.countriesWithState
                            }
                            onPayClick={() => this.onPayClick()}
                          />
                        )}
                      </div>
                    </PurchaseProtectedRoute>
                  }
                />

                <Route
                  path={`/success/:id`}
                  element={
                    <PurchaseProtectedRoute
                      checkOutId={this.checkOutId}
                      currentRoute={UpsertPurchaseActiveStep.Success}
                      purchaseStore={this.purchaseStore}
                      isPurchaseLink={this.props.isPurchaseLink}
                    >
                      <div className="flex-auto-grow purchase-confirmed">
                        <div>
                          <PurchaseSuccess
                            purchaseDoneResponse={
                              this.purchaseStore.purchaseDoneResponse
                            }
                            afterPayDetails={
                              this.purchaseStore.customerFacingCheckOutDetails
                                .afterPayDetails
                            }
                            buttonBgColor={
                              this.purchaseStore.getColors()?.primary?.rgba
                            }
                          />
                        </div>
                      </div>
                    </PurchaseProtectedRoute>
                  }
                />
                <Route
                  path="*"
                  element={
                    <Navigate
                      to={`/app/purchase/${this.props.isPurchaseLink ? "purchase-link" : "checkout"}/${this.checkOutId}`}
                    />
                  }
                />
              </Routes>
              {(showBackButton || showNextButton) && (
                <div>
                  <FlexContainer
                    justifyContent="center"
                    alignItems="center"
                    spacing={20}
                  >
                    {showBackButton && (
                      <CustomButton
                        // bgColor={colors?.primary?.rgba}
                        bgColor="#fff"
                        borderColor={colors?.primary?.rgba}
                        color={`${colors?.primary?.rgba} !important`}
                        className="purchase-main-btn"
                        onClick={() => this.handleBackOrNextStep(false)}
                        borderRadius={"4px !important"}
                      >
                        Back
                      </CustomButton>
                    )}
                    {showNextButton && (
                      <CustomButton
                        bgColor={colors?.primary?.rgba}
                        borderColor={colors?.primary?.rgba}
                        className="purchase-main-btn"
                        onClick={() => this.handleBackOrNextStep(true)}
                        borderRadius={"4px !important"}
                      >
                        Next
                      </CustomButton>
                    )}
                  </FlexContainer>
                </div>
              )}
            </>
          )}
        </div>
      </PurchaseColoredBackground>
    );
  }

  renderBottomContent = () => {
    return (
      <FlexContainer justifyContent="center" alignItems="center" size={0}>
        <CustomLabel className="purchase-footer">
          Powered by MindMe Payments | Terms | Privacy
        </CustomLabel>
      </FlexContainer>
    );
  };

  hasNonIncludedAddOns() {
    const hasAddOns =
      this.purchaseStore.checkOutPurchaseDetails &&
      this.purchaseStore.checkOutPurchaseDetails?.addOns?.filter(
        (a) => a.isIncludedItem !== true
      ).length > 0;
    return hasAddOns;
  }

  getNonIncludedAddOns(clonedPurchaseDetails: PurchaseCheckOutDetails) {
    const addons =
      clonedPurchaseDetails &&
      clonedPurchaseDetails?.addOns?.filter((a) => a.isIncludedItem !== true);

    return addons || [];
  }

  handleBackOrNextStep = (isNext: boolean) => {
    const isPurchaseLink = this.props.isPurchaseLink;
    const isDonationOnly =
      this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly;
    const baseRoute = isPurchaseLink
      ? "/app/purchase/purchase-link/"
      : "/app/purchase/checkout/";
    const addOnLink = baseRoute + "addons/" + this.checkOutId;
    const purchaseLink = baseRoute + this.checkOutId;
    const optionsLink = baseRoute + "options/" + this.checkOutId;
    const paymentLink = baseRoute + "payment/" + this.checkOutId;
    const hasAddOns = this.hasNonIncludedAddOns();
    let isValid = true;
    if (isNext && (!isDonationOnly || (isDonationOnly && hasAddOns))) {
      isValid = this.props.purchaseStore?.validate();

      if (this.purchaseStore.activeStep !== UpsertPurchaseActiveStep.Options) {
        if (!isValid) {
          return;
        }
      }
    }

    // const isProduct =
    //   this.purchaseStore.checkOutPurchaseDetails?.item.itemType === "Product";
    const hasVariants =
      this.purchaseStore.checkOutPurchaseDetails?.item.hasVariants;

    switch (this.purchaseStore.activeStep) {
      case UpsertPurchaseActiveStep.Purchase:
        // if (isDonationOnly) {
        //   this.purchaseStore.updateActiveStep(UpsertPurchaseActiveStep.Payment);
        //   this.redirectToPaymentPage(paymentLink);
        // }

        if (this.purchaseStore.showCheckOutAddOns()) {
          this.purchaseStore.updateActiveStep(UpsertPurchaseActiveStep.AddOn);
          this.props.navigate(addOnLink);
        } else {
          //IF DONATION AND DONATION HAS ADD ONS
          if (!isDonationOnly || (isDonationOnly && hasAddOns)) {
            if (hasVariants) {
              this.purchaseStore.updateActiveStep(
                UpsertPurchaseActiveStep.Options
              );
              this.props.navigate(optionsLink);
            } else {
              this.redirectToPaymentPage(paymentLink);
            }
          } else {
            this.redirectToPaymentPage(paymentLink);
          }
        }
        break;
      case UpsertPurchaseActiveStep.AddOn:
        if (isNext) {
          if (isDonationOnly && !hasAddOns) {
            this.redirectToPaymentPage(paymentLink);
          } else {
            // if (isProduct) {
            // if (hasVariants) {
            //   this.purchaseStore.updateActiveStep(
            //     UpsertPurchaseActiveStep.Options
            //   );
            //   this.props.navigate(optionsLink);
            // } else {
            //   this.redirectToPaymentPage(paymentLink);
            // }
            this.purchaseStore.updateActiveStep(
              UpsertPurchaseActiveStep.Options
            );
            this.props.navigate(optionsLink);
          }
        } else {
          this.purchaseStore.updateActiveStep(
            UpsertPurchaseActiveStep.Purchase
          );
          this.props.navigate(purchaseLink);
        }
        break;
      case UpsertPurchaseActiveStep.Options:
        this.verifyNavigationFromOptionsPage(
          paymentLink,
          addOnLink,
          purchaseLink,
          isNext,
          isValid
        );
        break;
      case UpsertPurchaseActiveStep.Payment:
        if (isNext) {
        } else if (isDonationOnly && !hasAddOns) {
          this.purchaseStore.updateActiveStep(
            UpsertPurchaseActiveStep.Purchase
          );
          this.props.navigate(purchaseLink);
        } else {
          if (this.purchaseStore.showCheckOutAddOns() || hasVariants) {
            this.purchaseStore.updateActiveStep(
              UpsertPurchaseActiveStep.Options
            );
            this.props.navigate(optionsLink);
          } else {
            this.verifyNavigationFromOptionsPage(
              paymentLink,
              addOnLink,
              purchaseLink,
              isNext,
              isValid
            );
          }
        }
        break;
      default:
        break;
    }
  };

  verifyNavigationFromOptionsPage = (
    paymentLink: string,
    addOnLink: string,
    purchaseLink: string,
    isNext: boolean,
    isValid: boolean
  ) => {
    const clonedPurchaseDetails = new PurchaseCheckOutDetails({
      ...this.purchaseStore.checkOutPurchaseDetails,
    });
    let activeItemIndex = clonedPurchaseDetails.activeItemIndex;
    const isDonationOnly =
      this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly;
    let move = false;
    if (activeItemIndex === -1) {
      if (this.hasNonIncludedAddOns()) {
        if (isNext) {
          //Allow Navigation for next add onitem
          clonedPurchaseDetails.activeItemIndex = 0;
        } else {
          move = true;
        }
      } else {
        move = true;
      }

      if (!isValid && isNext) {
        if (clonedPurchaseDetails.item.errors?.length > 0) {
          clonedPurchaseDetails.activeItemIndex = -1;
          move = false;
        }
      }
    } else {
      if (clonedPurchaseDetails.addOns?.length > 0) {
        if (isNext) {
          if (
            activeItemIndex ===
            this.getNonIncludedAddOns(clonedPurchaseDetails).length - 1
          ) {
            if (
              !isValid &&
              clonedPurchaseDetails.addOns[activeItemIndex].errors?.length > 0
            ) {
              move = false;
            } else {
              move = true;
            }
          } else {
            const addOnsToRotate = this.getNonIncludedAddOns(
              clonedPurchaseDetails
            ).filter((a, index) => index > activeItemIndex)[0].id;
            if (
              !isValid &&
              clonedPurchaseDetails.addOns[activeItemIndex].errors?.length > 0
            ) {
              move = false;
              clonedPurchaseDetails.activeItemIndex = activeItemIndex;
            } else {
              activeItemIndex = clonedPurchaseDetails.addOns.findIndex(
                (a) => a.id === addOnsToRotate
              );

              // clonedPurchaseDetails.activeItemIndex = activeItemIndex + 1;
              clonedPurchaseDetails.activeItemIndex = activeItemIndex;
            }
          }
        } else {
          if (activeItemIndex === -1) {
            move = true;
          } else {
            activeItemIndex = activeItemIndex - 1;
            clonedPurchaseDetails.activeItemIndex = activeItemIndex;
          }
        }
      } else {
        move = true;
      }
    }

    if (isDonationOnly && activeItemIndex === -1 && !isNext) {
      clonedPurchaseDetails.activeItemIndex = 0;
      this.purchaseStore.updateCheckOutPurchaseDetails(clonedPurchaseDetails);
      this.purchaseStore.updateActiveStep(UpsertPurchaseActiveStep.Purchase);
      this.props.navigate(purchaseLink);

      return;
    }

    if (move) {
      if (isNext) {
        this.redirectToPaymentPage(paymentLink);
      } else {
        if (this.purchaseStore.showCheckOutAddOns()) {
          this.purchaseStore.updateActiveStep(UpsertPurchaseActiveStep.AddOn);
          this.props.navigate(addOnLink);
        } else {
          this.purchaseStore.updateActiveStep(
            UpsertPurchaseActiveStep.Purchase
          );
          this.props.navigate(purchaseLink);
        }
      }
    } else {
      this.purchaseStore.updateCheckOutPurchaseDetails(clonedPurchaseDetails);
    }
  };

  redirectToPaymentPage = (paymentLink: string) => {
    this.paymentLoader.show();
    this.purchaseStore.updateActiveStep(UpsertPurchaseActiveStep.Payment);
    const type = this.props.isPurchaseLink ? "PurchaseLink" : "CheckOut";
    CheckOutService.createPaymentIntent(
      type,
      this.purchaseStore.customerFacingCheckOutDetails.accountId,
      this.checkOutId
    ).subscribe({
      next: (result) => {
        if (!result.result) {
          ToastService.showError("Error in creating payment intent");
        } else {
          this.purchaseStore.updatePaymentIntent(
            PurchasePaymentIntentModel.deserializeAPIModel(result.result)
          );
          this.props.navigate(paymentLink);
        }
        this.paymentLoader.hide();
      },
      error: () => {
        ToastService.showError("Error in creating payment intent");
        this.paymentLoader.hide();
      },
    });
  };

  onTabChange = (key: string) => {
    const step = key as UpsertPurchaseActiveStep;
    const isPurchaseLink = this.props.isPurchaseLink;
    const baseRoute = isPurchaseLink
      ? "/app/purchase/purchase-link/"
      : "/app/purchase/checkout/";
    const paymentLink = baseRoute + "payment/" + this.checkOutId;

    const stepToUrl = {
      [UpsertPurchaseActiveStep.Purchase]: `${baseRoute}${this.checkOutId}`,
      [UpsertPurchaseActiveStep.AddOn]: `${baseRoute}addons/${this.checkOutId}`,
      [UpsertPurchaseActiveStep.Options]: `${baseRoute}options/${this.checkOutId}`,
      [UpsertPurchaseActiveStep.Payment]: `${baseRoute}payment/${this.checkOutId}`,
      [UpsertPurchaseActiveStep.Success]: `${baseRoute}payment/${this.checkOutId}`,
    };

    const { isValid, errorStep } =
      this.props.purchaseStore.validatePreviousSteps(step);

    if (!isValid) {
      const stepNames = {
        [UpsertPurchaseActiveStep.Purchase]:
          "Please select an item to purchase",
        [UpsertPurchaseActiveStep.AddOn]: "",
        [UpsertPurchaseActiveStep.Options]: "",
        [UpsertPurchaseActiveStep.Payment]: "Please fill the data",
        [UpsertPurchaseActiveStep.Success]: " ",
      };
      const errorMessage = errorStep ? stepNames[errorStep] : "";
      if (errorStep) {
        if (errorStep === UpsertPurchaseActiveStep.Purchase) {
          ToastService.showError(errorMessage);
        }
        this.props.purchaseStore?.updateActiveStep(errorStep);
        this.props.navigate(`${stepToUrl[errorStep]}`);
      }
      return;
    }

    if (step === UpsertPurchaseActiveStep.Payment) {
      this.redirectToPaymentPage(paymentLink);
      return;
    }

    this.props.purchaseStore.updateActiveStep(step);
    this.props.navigate(`${stepToUrl[step]}`);
  };

  render(): ReactNode {
    const colors = this.purchaseStore.getColors();
    const isDonationOnly =
      this.purchaseStore.customerFacingCheckOutDetails.isDonationOnly;
    const showLogo = this.props.isPurchaseLink
      ? true
      : this.purchaseStore.customerFacingCheckOutDetails.options.brandingData
          .showLogo;
    const showHelp =
      this.purchaseStore.customerFacingCheckOutDetails.options.brandingData
        .showHelp;
    const showTopBarForDonation = (showLogo || showHelp) && isDonationOnly;

    return (
      <PurchaseWrapper
        bgColor={colors?.pageBackground?.rgba}
        className={showHelp || showLogo ? "purchase-wrapper-logo-help" : ""}
      >
        {!this.purchaseStore.purchaseDone && (
          <div>
            <PurchaseTopBar
              purchaseStore={this.purchaseStore}
              id={this.checkOutId}
              showLogo={showLogo}
              showHelp={showHelp}
              onTabChange={(key: UpsertPurchaseActiveStep) =>
                this.onTabChange(key)
              }
              brandingData={
                this.purchaseStore.customerFacingCheckOutDetails.options
                  ?.brandingData
              }
              activeStep={this.purchaseStore.activeStep}
              seller={this.purchaseStore.customerFacingCheckOutDetails.seller}
            />
          </div>
        )}
             {/* ${this.purchaseStore.customerFacingCheckOutDetails.options.brandingData.showHelp ? "middle-panel-with-topbar" : ""} */}
        <div
          className={`purchase-middle-panel
              ${showTopBarForDonation ? "purchase-donation-topbar-middle" : "purchase-donation-wo-topbar"}`}
        >
          {" "}
          {AccountSettingsStore.isLoadingInProgress || this.loader.showLoader
            ? this.loader.loaderComponent
            : this.routes}
        </div>
        {/* Commented for now */}
        {/* <div>{this.renderBottomContent()}</div> */}
      </PurchaseWrapper>
    );
  }
}

export default withRouter(observer(PurchaseRoutes));
